module.exports = (__webpack_require__(3))(35);


//////////////////
// WEBPACK FOOTER
// delegated ./src/router.js from dll-reference girder_plugin_large_image_annotation
// module id = 37
// module chunks = 0